import type { GameDto } from '@/queries/games/games.schema';

type GameIframeGame = Pick<GameDto, 'name' | 'settings'> & {
  provider?: Pick<NonNullable<GameDto['provider']>, 'settings'> | null;
};

type GameIframeProps = {
  className?: string;
  game?: GameIframeGame;
  src: string;
};

export const GameIframe = ({ className, game, src }: GameIframeProps) => {
  const allow = game?.settings?.allow || game?.provider?.settings?.allow || undefined;

  return (
    <iframe
      src={src}
      title={`Game iframe: ${game?.name}`}
      className={className}
      allowFullScreen
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      allow={allow}
    />
  );
};
